import Vue from 'vue';
import Vuex from 'vuex';
import motor from './modules/motor';
import emailConfirmation from './modules/email-confirmation';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    motor,
    emailConfirmation
  }
});
